"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalWorkflowExecutionManager = void 0;
var types_core_1 = require("@augloop/types-core");
var interfaces_1 = require("@augloop/interfaces");
var logging_1 = require("@augloop/logging/dist/src/client/logging");
var session_protocol_1 = require("@augloop/session-protocol");
var session_1 = require("./session");
var annotation_meta_data_change_1 = require("@augloop/logging/dist/src/annotation-meta-data-change");
var workflow_model_1 = require("./workflow-model");
var utils_1 = require("./utils");
var delayMillisecondsIfRequiredContextsNotReady = 500;
var LocalWorkflowExecutionManager = /** @class */ (function () {
    function LocalWorkflowExecutionManager(modelDownloader, inferenceService) {
        var _this = this;
        this.workflowsWithSessionAffinity = new Map();
        this.workflowDefinitionsWithSessionAffinity = [];
        this.workflowsWithoutSessionAffinity = [];
        this.nextAnnotationId = 1;
        this.nextSignalId = 1;
        this.modelDownloader = modelDownloader;
        this.inferenceService = inferenceService;
        if (inferenceService) {
            inferenceService.catch((function () {
                _this.inferenceService = undefined;
            }).bind(this));
        }
    }
    LocalWorkflowExecutionManager.prototype.getNextClientAnnotationId = function () {
        return '#AC' + this.nextAnnotationId++;
    };
    LocalWorkflowExecutionManager.prototype.getNextClientSignalId = function () {
        return '#SC' + this.nextSignalId++;
    };
    LocalWorkflowExecutionManager.prototype.registerLocalWorkflow = function (workflow) {
        var _this = this;
        var op = new logging_1.Operation({
            operationName: 'WorkflowRegistration',
            resourceId: workflow.id
        }).start();
        if (workflow.inputTypes.length === 0) {
            throw new Error("Invalid workflow params");
        }
        else {
            if (workflow.isStateful) {
                this.workflowDefinitionsWithSessionAffinity.push(workflow);
                this.workflowsWithSessionAffinity.forEach(function (workflows) {
                    workflows.push(_this.createWorkflowImplementation(workflow));
                });
            }
            else {
                this.workflowsWithoutSessionAffinity.push(this.createWorkflowImplementation(workflow));
            }
            this.workflowsWithSessionAffinity.forEach(function (_workflows, session) { return session.registerContextTypes(workflow.requiredContextTypes, workflow.optionalContextTypes); });
            op.success = true;
            logging_1.Log.info(0x2224d0de /* tag_8jnd4 */, logging_1.LogCategory.CoreDefault, op.stop());
        }
    };
    // Registers workflow only for the session provided
    LocalWorkflowExecutionManager.prototype.registerSessionLocalWorkflow = function (workflow, session) {
        var op = new logging_1.Operation({
            operationName: 'WorkflowRegistration',
            resourceId: workflow.id
        }).start();
        if (workflow.inputTypes.length === 0) {
            throw new Error("Invalid workflow params");
        }
        else {
            this.workflowsWithSessionAffinity.get(session).push(this.createWorkflowImplementation(workflow));
            session.registerContextTypes(workflow.requiredContextTypes, workflow.optionalContextTypes);
            op.success = true;
            logging_1.Log.info(0x2151c515 /* tag_7u2uv */, logging_1.LogCategory.CoreDefault, op.stop());
        }
    };
    LocalWorkflowExecutionManager.prototype.addSession = function (session) {
        var sessionWorkflowImplementation = [];
        for (var _i = 0, _a = this.workflowDefinitionsWithSessionAffinity; _i < _a.length; _i++) {
            var workflow = _a[_i];
            sessionWorkflowImplementation.push(this.createWorkflowImplementation(workflow));
        }
        this.workflowsWithSessionAffinity.set(session, sessionWorkflowImplementation);
    };
    LocalWorkflowExecutionManager.prototype.closeSession = function (session) {
        this.workflowsWithSessionAffinity.delete(session);
    };
    LocalWorkflowExecutionManager.prototype.runLocalWorkflows = function (operations, session) {
        var _this = this;
        var _a;
        var checkItemAndExecute = function (workflowImplementation, opItem, operation) {
            var _a;
            if (types_core_1.SchemaObject.matchesTypesFor(opItem.body, workflowImplementation.workflow.inputTypes)) {
                var itemWithPath_1 = utils_1.shallowCloneItemWithPath(operation.parentPath, opItem);
                // Since we don't have session cache locally yet, we have a workaround for user context producer workflows by adding UserContextHolder to each submitted operations array.
                // However, we need to avoid trigger user (and tenant, group) context producer workflow on each submit and to run it just once.
                // TODO #5326116: Adapt this once session cache is available for local workflows.
                if (types_core_1.SchemaObject.getBaseTypesFor(opItem.body).includes(types_core_1.ContextHolder.getTypeName())) {
                    var contextHolderPath = __spreadArrays(itemWithPath_1.parentPath, [itemWithPath_1.id]);
                    var allContextsAlreadyAvailable = true;
                    for (var _i = 0, _b = (_a = workflowImplementation.workflow.outputTypes) !== null && _a !== void 0 ? _a : []; _i < _b.length; _i++) {
                        var contextOutputType = _b[_i];
                        if (!session.getContextAnnotations(contextOutputType, session_1.ContextAnnotationSources.LocalWorkflow, contextHolderPath, workflowImplementation.workflow.id)) {
                            allContextsAlreadyAvailable = false;
                            break;
                        }
                    }
                    // If all contexts are already available on a given path, then skip execution of this context producer workflow.
                    if (allContextsAlreadyAvailable) {
                        return;
                    }
                }
                var execute_1 = function () {
                    var _a = session.resolveRequestedContexts(workflowImplementation.workflow), areRequiredContextsReady = _a[0], requestedContexts = _a[1];
                    if (areRequiredContextsReady) {
                        _this.executeLocalWorkflow(workflowImplementation, [itemWithPath_1], session, requestedContexts).catch(function (error) {
                            logging_1.Log.error(0x2224d0df /* tag_8jnd5 */, logging_1.LogCategory.CoreDefault, error);
                        });
                    }
                    else {
                        logging_1.Log.info(0x2088d0cb /* tag_68ndl */, logging_1.LogCategory.WorkflowDefault, "Required contexts are not ready for " + workflowImplementation.workflow.id + ". Retrying execution in " + delayMillisecondsIfRequiredContextsNotReady + " milliseconds...");
                        setTimeout(execute_1, delayMillisecondsIfRequiredContextsNotReady);
                    }
                };
                execute_1();
            }
        };
        // Prepend artificial UserContextHolder and TenantContextHolder to provided operations, so local user and tenant context producer workflows can have input and get executed. Prepend instead of append as a best effort try to have context created before execution of context consumer workflows.
        // TODO #5326116: Refactor this to use UserContextHolder and TenantContextHolder from session cache once it's available for local workflows.
        for (var _i = 0, _b = [new types_core_1.AddOperation({ parentPath: ['session'], items: [{ id: '#userContext#', body: new types_core_1.UserContextHolder() }] }), new types_core_1.AddOperation({ parentPath: ['session'], items: [{ id: '#tenantContext#', body: new types_core_1.TenantContextHolder() }] })].concat(operations); _i < _b.length; _i++) {
            var operation = _b[_i];
            var opType = types_core_1.SchemaObject.getTypeNameFor(operation);
            for (var _c = 0, _d = operation.items; _c < _d.length; _c++) {
                var opItem = _d[_c];
                session.applyOperationForContext(operation, opItem, session_1.ContextAnnotationSources.Submitted);
                // Check that the item(s) in question is not being deleted
                // Currently, AL cache is not stored/available locally
                if (opType === types_core_1.DeleteOperation.getTypeName()) {
                    continue;
                }
                if (!opItem.body) {
                    continue;
                }
                for (var _e = 0, _f = this.workflowsWithoutSessionAffinity; _e < _f.length; _e++) {
                    var workflowImplementation = _f[_e];
                    checkItemAndExecute(workflowImplementation, opItem, operation);
                }
                for (var _g = 0, _h = (_a = this.workflowsWithSessionAffinity.get(session)) !== null && _a !== void 0 ? _a : []; _g < _h.length; _g++) {
                    var workflowImplementation = _h[_g];
                    checkItemAndExecute(workflowImplementation, opItem, operation);
                }
            }
        }
    };
    LocalWorkflowExecutionManager.prototype.createWorkflowImplementation = function (workflow) {
        var workflowLambda = workflow.factory();
        var workflowImplementation = {
            workflow: workflow,
            workflowLambda: workflowLambda,
            initPromise: this.initWorkflow(workflow.kind, workflowLambda)
        };
        return workflowImplementation;
    };
    LocalWorkflowExecutionManager.prototype.getResourceAsArrayBuffer = function (modelId, version) {
        if (this.modelDownloader) {
            return this.modelDownloader.getResourceAsArrayBuffer(modelId, version);
        }
        else {
            return Promise.reject(new Error('Resource Downloader never created'));
        }
    };
    LocalWorkflowExecutionManager.prototype.getResourceAsURL = function (modelId, version) {
        if (this.modelDownloader) {
            return this.modelDownloader.getResourceAsURL(modelId, version);
        }
        else {
            return Promise.reject(new Error('Resource Downloader never created'));
        }
    };
    LocalWorkflowExecutionManager.prototype.createModel = function (modelUrl) {
        if (this.inferenceService) {
            return this.inferenceService.then(function (service) {
                return service.createModel(modelUrl);
            });
        }
        else {
            return Promise.reject(new Error('Inference Service never created'));
        }
    };
    LocalWorkflowExecutionManager.prototype.createModelInputs = function () {
        if (this.inferenceService) {
            return this.inferenceService.then(function (service) {
                return service.createInputs();
            });
        }
        else {
            throw new Error('Inference Service never created');
        }
    };
    LocalWorkflowExecutionManager.prototype.initWorkflow = function (workflowKind, workflowLambda) {
        if (workflowKind == interfaces_1.WorkflowKind.SingleItem) {
            var site = {
                getResourceAsArrayBuffer: this.getResourceAsArrayBuffer.bind(this),
                getResourceAsURL: this.getResourceAsURL.bind(this),
                createModel: this.createModel.bind(this),
                createModelInputs: this.createModelInputs.bind(this),
            };
            return workflowLambda.init(site);
        }
        else {
            return Promise.resolve();
        }
    };
    LocalWorkflowExecutionManager.prototype.executeLocalWorkflow = function (workflowInfo, inputItems, session, requestedContexts) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var workflow = workflowInfo.workflow;
            var executeOp = new logging_1.Operation({
                operationName: 'ExecuteWorkflow',
                resourceId: workflow.id
            });
            executeOp.start();
            var endOp = function (error) {
                if (error) {
                    executeOp.resultDescription = error;
                    executeOp.resultSignature = 'Exception';
                    logging_1.Log.error(0x2224d0e0 /* tag_8jnd6 */, logging_1.LogCategory.CoreDefault, executeOp.stop());
                }
                else {
                    executeOp.success = true;
                    logging_1.Log.info(0x2224d0e1 /* tag_8jnd7 */, logging_1.LogCategory.CoreDefault, executeOp.stop());
                }
                return error;
            };
            var setAnnotations = function (obj, annotationType, annotations, options) {
                var _a;
                var logAnnotationMetadata = function (state) {
                    logging_1.Log.info(0x2121d800 /* tag_7i36a */, logging_1.LogCategory.CoreDefault, new annotation_meta_data_change_1.AnnotationMetaDataChange({ annotationType: annotationType, annotationState: state, workflowId: workflowInfo.workflow.id }));
                };
                for (var _i = 0, annotations_1 = annotations; _i < annotations_1.length; _i++) {
                    var annotation = annotations_1[_i];
                    annotation.metadata = __assign(__assign({}, annotation.metadata), { state: types_core_1.AnnotationState.Created });
                    logAnnotationMetadata(types_core_1.AnnotationState.Created);
                }
                // Has to be true since only single-item workflows are currently supported
                if (inputItems[0].body !== obj) {
                    reject(endOp("Expected obj to be " + inputItems[0].body + " but instead it was " + obj));
                    return;
                }
                var item = inputItems[0];
                var itemBodyType = types_core_1.SchemaObject.getTypeNameFor(item.body);
                var error;
                // Check that annotations match expectations - otherwise workflow author must fix
                if (!Array.isArray(annotations)) {
                    error = "Workflow produced an invalid annotation array";
                }
                else if (!workflow.outputTypes || workflow.outputTypes.indexOf(annotationType) < 0) {
                    error = "Workflow said it would output one of [" + workflow.outputTypes + "] but instead output " + annotationType;
                }
                else if (!item) {
                    error = "No item provided";
                }
                else {
                    for (var _b = 0, annotations_2 = annotations; _b < annotations_2.length; _b++) {
                        var annotation = annotations_2[_b];
                        if (!types_core_1.SchemaObject.matchesTypesFor(annotation, [types_core_1.Annotation.getTypeName()])) {
                            error = "Workflow produced an output that is not an annotation " + types_core_1.SchemaObject.getTypeNameFor(annotation);
                        }
                        else if (types_core_1.SchemaObject.getTypeNameFor(annotation) !== annotationType) {
                            error = "Workflow produced inconsistent annotation types in setAnnotations call (" + types_core_1.SchemaObject.getTypeNameFor(annotation) + " did not match expected " + annotationType + ")";
                        }
                    }
                }
                if (error) {
                    reject(endOp(error));
                    return;
                }
                // Path to where the annotation will be added
                var path;
                if (options && options.isSessionAnnotation) {
                    path = ['session'];
                }
                else if (options && options.ancestorType) {
                    path = item.parentPath;
                }
                else {
                    path = item.parentPath.concat(item.id);
                }
                // Changing annotations into items and setting metadata to sent
                var annotationsToAdd = [];
                var annotationsToUpdate = [];
                var _loop_1 = function (annotation) {
                    annotation.metadata = __assign(__assign({}, annotation.metadata), { state: types_core_1.AnnotationState.Sent });
                    logAnnotationMetadata(types_core_1.AnnotationState.Sent);
                    var annotationId = annotation.id;
                    var existingContextAnnotations = annotationId ? (_a = session.getContextAnnotations(annotationType, session_1.ContextAnnotationSources.LocalWorkflow, path, workflow.id)) === null || _a === void 0 ? void 0 : _a.filter(function (context) { var _a; return ((_a = context.body) === null || _a === void 0 ? void 0 : _a.id) == annotationId; }) : undefined;
                    if ((existingContextAnnotations === null || existingContextAnnotations === void 0 ? void 0 : existingContextAnnotations.length) == 1) {
                        if (existingContextAnnotations.length == 1) {
                            annotationsToUpdate.push({
                                id: existingContextAnnotations[0].id,
                                source: workflow.id,
                                body: annotation
                            });
                        }
                        else {
                            logging_1.Log.error(0x2088d0cc /* tag_68ndm */, logging_1.LogCategory.CoreDefault, "Assert: Multiple existing context annotations with body id " + annotationId + " found for " + annotationType + " and local workflow " + workflow.id + ").");
                        }
                    }
                    else {
                        annotationsToAdd.push({
                            id: _this.getNextClientAnnotationId(),
                            source: workflow.id,
                            body: annotation
                        });
                    }
                };
                for (var _c = 0, annotations_3 = annotations; _c < annotations_3.length; _c++) {
                    var annotation = annotations_3[_c];
                    _loop_1(annotation);
                }
                var ops = [];
                if (annotationsToAdd.length > 0) {
                    ops.push(new types_core_1.AddOperation({ parentPath: path, items: annotationsToAdd }));
                }
                if (annotationsToUpdate.length > 0) {
                    ops.push(new types_core_1.UpdateOperation({ parentPath: path, items: annotationsToUpdate }));
                }
                session.onAnnotationResults(new session_protocol_1.AnnotationResultsMessage({
                    annotationType: annotationType,
                    ops: ops
                }), session_1.ContextAnnotationSources.LocalWorkflow, function () { }); // Empty response callback because we don't need to acknowledge annotations are received
                // If this is a context annotation, submit it directly to the server, so the server workflows can consume it as well.
                // Note: We're intentionally not checking whether the produced context type is registered locally because we locally don't have a knowledge about requested context types for server workflows and we want to send locally produced context annotation so server workflows can use them.
                if (itemBodyType == types_core_1.UserContextHolder.getTypeName() || itemBodyType == types_core_1.TenantContextHolder.getTypeName() || types_core_1.SchemaObject.matchesTypesFor(item.body, [types_core_1.Document.getTypeName(), types_core_1.SubDocument.getTypeName()])) {
                    session.submitOperationsToServer(ops);
                }
            };
            var submitSignals = function (signals) {
                // Changing signals into items
                var signalItemsArray = signals.map(function (signal) {
                    return {
                        id: _this.getNextClientSignalId(),
                        source: workflow.id,
                        body: signal
                    };
                });
                var submitOp = new types_core_1.SignalOperation({
                    parentPath: ['session'],
                    items: signalItemsArray
                });
                session.submitOperations([submitOp]);
            };
            var context = {
                model: new workflow_model_1.WorkflowModel(inputItems[0], requestedContexts),
                getToken: undefined,
                clientMetadata: session.getClientMetadata(),
                site: {
                    getResourceAsArrayBuffer: _this.getResourceAsArrayBuffer.bind(_this),
                    getResourceAsURL: _this.getResourceAsURL.bind(_this),
                    createModel: _this.createModel.bind(_this),
                    createModelInputs: _this.createModelInputs.bind(_this),
                },
            };
            var site = {
                getResourceAsArrayBuffer: _this.getResourceAsArrayBuffer.bind(_this),
                getResourceAsURL: _this.getResourceAsURL.bind(_this),
                createModel: _this.createModel.bind(_this),
                createModelInputs: _this.createModelInputs.bind(_this),
            };
            var workflowExecutionDone = function (err) {
                endOp(err ? err.message : null);
                if (err) {
                    reject(err);
                }
                else {
                    resolve();
                }
            };
            var actions = {
                setAnnotations: setAnnotations.bind(_this),
                submitSignals: submitSignals.bind(_this),
                done: workflowExecutionDone.bind(_this),
            };
            var workflowInstance = workflowInfo.workflowLambda;
            if (workflow.kind === interfaces_1.WorkflowKind.SingleItem) {
                if (inputItems.length !== 1) {
                    endOp('Single item workflows expect a single input');
                }
                context.delta = inputItems[0].delta;
                try {
                    var singleItemWorkflow_1 = workflowInstance;
                    if (!workflowInfo.initPromise) {
                        workflowInfo.initPromise = singleItemWorkflow_1.init(site);
                    }
                    workflowInfo.initPromise.then(function () {
                        singleItemWorkflow_1.execute(inputItems[0].body, context, actions);
                    }).catch(function (error) {
                        endOp(error);
                    });
                }
                catch (error) {
                    endOp(error);
                }
            }
            else {
                endOp("Only single item workflows supported currently");
            }
        });
    };
    return LocalWorkflowExecutionManager;
}());
exports.LocalWorkflowExecutionManager = LocalWorkflowExecutionManager;
//# sourceMappingURL=local-workflow-execution-manager.js.map